import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ArrowDownLeft, ArrowUpRight, Sparkles, Shirt, Package, Wrench, CheckSquare, FileText, Home, Users } from "lucide-react";

const ACTIONS = [
  { key: "tx-in", label: "Entrata", icon: ArrowDownLeft, to: "/incassi-pagamenti?new=income", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { key: "tx-out", label: "Uscita", icon: ArrowUpRight, to: "/incassi-pagamenti?new=expense", color: "bg-rose-50 text-rose-700 border-rose-200" },
  { key: "clean", label: "Pulizia", icon: Sparkles, to: "/pulizie?new=1", color: "bg-sky-50 text-sky-700 border-sky-200" },
  { key: "laundry-cost", label: "Costo lavanderia", icon: Shirt, to: "/lavanderia?new=costo", color: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { key: "laundry-del", label: "Consegna lavanderia", icon: Shirt, to: "/lavanderia?new=consegna", color: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  { key: "consum", label: "Consumabile", icon: Package, to: "/consumabili?new=1", color: "bg-amber-50 text-amber-800 border-amber-200" },
  { key: "maint", label: "Manutenzione", icon: Wrench, to: "/manutenzioni?new=1", color: "bg-orange-50 text-orange-700 border-orange-200" },
  { key: "task", label: "Todo", icon: CheckSquare, to: "/todo?new=1", color: "bg-slate-50 text-slate-700 border-slate-200" },
  { key: "report", label: "Rendiconto", icon: FileText, to: "/rendiconti?new=1", color: "bg-teal-50 text-teal-800 border-teal-200" },
  { key: "apt", label: "Appartamento", icon: Home, to: "/appartamenti?new=1", color: "bg-purple-50 text-purple-700 border-purple-200" },
  { key: "own", label: "Proprietario", icon: Users, to: "/proprietari?new=1", color: "bg-pink-50 text-pink-700 border-pink-200" },
];

export default function QuickAdd({ open, onOpenChange }) {
  const nav = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="quick-add-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Cosa vuoi aggiungere?</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-2">
          {ACTIONS.map((a) => (
            <button key={a.key} data-testid={`quickadd-${a.key}`}
              onClick={() => { onOpenChange(false); nav(a.to); }}
              className={`flex flex-col items-start gap-2 p-4 rounded-2xl border ${a.color} hover:shadow-md hover:-translate-y-0.5 transition text-left min-h-[44px]`}>
              <a.icon className="h-5 w-5" />
              <span className="text-sm font-semibold leading-tight">{a.label}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
